/** Which version of a project's briefing the page shows (BriefingFrame provides it). */
import { createContext, useContext } from "react";

export interface BriefingView {
  /** The earlier version being shown, or null for the latest. */
  version: number | null;
  latest: number;
}

export const BriefingViewContext = createContext<BriefingView>({ version: null, latest: 0 });

export const useBriefingView = (): BriefingView => useContext(BriefingViewContext);
